export const disclaimerIdForEmailLink = 'disclaimer'
